<template>
  <div>
    <div class="titleh1"><code />运单</div>
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      class="demo-ruleForm"
      disabled
    >
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="发货联系人" prop="coalNumber">
              <el-input
                v-model="form.order.shipperName"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="联系电话" prop="coalNumber">
              <el-input
                v-model="form.order.shipperPhone"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="装货地址" prop="coalNumber">
              <el-input
                v-model="form.order.shipperAddress"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="装货日期" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.fillTime"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="卸货联系人" prop="coalNumber">
              <el-input
                v-model="form.order.consigneeName"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="收获电话" prop="coalNumber">
              <el-input
                v-model="form.order.consigneePhone"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="收货地址" prop="coalNumber">
              <el-input
                v-model="form.order.consigneeAddress"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="签收日期" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.signTime"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="订单编号" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.orderCode"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="订单状态" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.status"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="货物" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.coalTypeName"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="货物描述" prop="coalNumber">
              <el-input
                v-model="form.order.coalName"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="装货重量" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.loadQuantity"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="卸货重量" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.unloadQuantity"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="货物损坏" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.wastage"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="托运人实收运费" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.shipperDeliveryFee"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="实际承运人实收运费" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.deliveryFeePractical"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="现金" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.deliveryCashFee"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="油气卡" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.deliveryOilFee"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="货物单价" prop="coalNumber">
              <el-input
                v-model="form.order.coalPrice"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <!--        <el-col :span="8">-->
        <!--          <div class="grid-content bg-purple-light">-->
        <!--            <el-form-item label="装车费" prop="coalNumber">-->
        <!--              <el-input placeholder="请输入内容" v-model="form.input" :disabled="true"></el-input>-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--        <el-col :span="8">-->
        <!--          <div class="grid-content bg-purple">-->
        <!--            <el-form-item label="卸车费" prop="coalNumber">-->
        <!--              <el-input placeholder="请输入内容" v-model="form.input" :disabled="true"></el-input>-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--      </el-row>-->
        <!--      <el-row>-->
        <!--        <el-col :span="8">-->
        <!--          <div class="grid-content bg-purple">-->
        <!--            <el-form-item label="超时费" prop="coalNumber">-->
        <!--              <el-input placeholder="请输入内容" v-model="form.input" :disabled="true"></el-input>-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--        <el-col :span="8">-->
        <!--          <div class="grid-content bg-purple-light">-->
        <!--            <el-form-item label="扣回单费" prop="coalNumber">-->
        <!--              <el-input placeholder="请输入内容" v-model="form.input" :disabled="true"></el-input>-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </el-col>-->
        <!--        <el-col :span="8">-->
        <!--          <div class="grid-content bg-purple">-->
        <!--            <el-form-item label="公里数" prop="coalNumber">-->
        <!--              <el-input placeholder="请输入内容" v-model="form.input" :disabled="true"></el-input>-->
        <!--            </el-form-item>-->
        <!--          </div>-->
        <!--        </el-col>-->
      </el-row>

      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="公里数" prop="coalNumber">
              <el-input
                v-model="form.order.distance"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="上传装货位置" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.loadPlace"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="上传卸货位置" prop="coalNumber">
              <el-input
                v-model="form.orderDetail.unloadPlace"
                placeholder="请输入内容"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="titleh1"><code />轨迹</div>
    <el-row>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <div style="height: 300px;">
            <el-steps direction="vertical" :active="1">
              <el-step
                title="步骤 1"
                description="这是一段很长很长很长的描述性文字"
              />
              <el-step
                title="步骤 2"
                description="这是一段很长很长很长的描述性文字"
              />
              <el-step
                title="步骤 3"
                description="这是一段很长很长很长的描述性文字"
              />
            </el-steps>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple-light" />
      </el-col>
    </el-row>
    <div class="titleh1"><code />评价</div>
    <el-row>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <p>实际承运人评价托运人</p>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple-light">
          <p>托运人评价实际承运人</p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { OrderDetails } from "@/api/transport";
export default {
  data() {
    return {
      form: {
        // order: [],
        // orderDetail: [] // ,
        // consigneeName: '',
        // consigneePhone: '',
        // consigneeAddress: '',
        // shipperName: '',
        // shipperPhone: '',
      }
    };
  },
  mounted() {},
  methods: {
    Getdetails(c) {
      OrderDetails(c).then(response => {
        this.form = response.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
.el-autocomplete {
  width: 81%;
}
</style>
